import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
	likes: [],
	products: [],
	isShowLikedProducts: false,
	slicedProducts: [],
	likeCount: 0
};

export const getProducts = createAsyncThunk("getProducts", async () => {
	try {
		const response = await axios.get("https://honey-badgers-ecommerce.glitch.me/products")
		return response.data;
	} catch (error) {
		return
	}
}
);

export const counterSlice = createSlice({
	name: 'counter',
	initialState,
	reducers: {
		addLikeToProduct: (state, action) => {
			state.likes = state.likes.find((like) => like.id === action.payload.id) ? state.likes.filter((like) => like.id !== action.payload.id) : [...state.likes, { ...action.payload, isLiked: true }];
			state.products = state.products.map((product) => product.id === action.payload.id ? { ...product, isLiked: !product.isLiked } : product)
		},
		setShowLikedProducts: (state) => {
			state.isShowLikedProducts = !state.isShowLikedProducts;
		},
	},
	extraReducers: {
		[getProducts.fulfilled]: (state, action) => {
			state.products = action.payload.map((product) => ({ ...product, isLiked: false }));
		},
	}
});

export const { addLikeToProduct, setShowLikedProducts } = counterSlice.actions;
export default counterSlice.reducer;